import * as Sentry from '@sentry/react-router'
import type { LinksFunction, MetaFunction, LoaderFunctionArgs } from 'react-router'
import {
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useRouteError,
	isRouteErrorResponse,
	redirect
} from 'react-router'

import stylesheet from '~/global.css?url'
import { userHasValidAuthToken } from '~/application/auth/UserHasValidAuthorizationToken'

export const meta: MetaFunction = () => [{ title: 'Partino Floatbridge' }]

export const links: LinksFunction = () => [
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	{ rel: 'stylesheet', href: stylesheet },
	{ rel: 'icon', type: 'image/png', href: '/logo_o.png' },
	{ rel: 'apple-touch-icon', href: '/logo_o.png' }
]

function isRootAuthExcludedPath(pathname: string) {
	const firstSegment = pathname.split('/')[1]
	return ['login', 'signup', 'forgot-password', 'reset-password', 'auth', 'api', 'resource'].includes(firstSegment)
}

export async function loader({ request, url }: LoaderFunctionArgs) {
	if (isRootAuthExcludedPath(url.pathname)) {
		return null
	}

	const sessionResult = await userHasValidAuthToken(request)

 	if (sessionResult.success === false) {
		const { sessionCookie } = sessionResult.error
		return redirect('/login', sessionCookie === undefined ? undefined : {
			headers: { 'set-cookie': sessionCookie },
		})
	}

	if ('data' in sessionResult) {
		return new Response(null, {
			headers: { 'set-cookie': sessionResult.data },
		})
	}

	return null
}

export function shouldRevalidate() {
	return true
}

function App() {
	return (
		<html lang="en" className="h-full">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width,initial-scale=1" />
				<Meta />
				<Links />
			</head>
			<body className="mx-auto w-[80rem] 2xl:w-[90rem] h-full bg-background-color">
				<Outlet />
				<ScrollRestoration />
				<Scripts />
			</body>
		</html>
	)
}

export default App

export function ErrorBoundary() {
	const error = useRouteError()
	console.error(error)
	if (!isRouteErrorResponse(error)) {
		Sentry.captureException(error instanceof Error ? error : new Error(String(error)))
	}
	return (
		<html lang="en-US" className="h-full">
			<head>
				<meta charSet="utf-8" />
				<title>Oh no!</title>
				<Meta />
				<Links />
			</head>
			<body className="h-full items-center">
				<div className="flex flex-col justify-center items-center h-full">
					<h1 className="text-4xl font-extrabold">Wow, you crashed us</h1>
					No bonuses for developers this year!
				</div>
				<Scripts />
			</body>
		</html>
	)
}